import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalappdev/app/components/GlobalErrorHandlerInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalappdev/app/components/PaymentReturnBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalappdev/app/components/PerformanceDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalappdev/app/components/PerformanceMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/smartportalappdev/app/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/smartportalappdev/app/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerformanceProvider"] */ "/var/www/smartportalappdev/app/contexts/PerformanceContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalappdev/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalappdev/app/navigation/NavigationProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/var/www/smartportalappdev/app/notifications/NotificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalappdev/components/auth/AuthWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalappdev/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/var/www/smartportalappdev/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalappdev/node_modules/react-toastify/dist/ReactToastify.css");
